import { UserSummary, userSummaryFromResponse } from './UserSummary';

export interface UserDetails extends UserSummary {
  role: string;
  companyID: number;
  affiliateCode?: string;
  affiliateEnabled: boolean;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
}

export const userDetailsFromResponse = (responseData: any): UserDetails => ({
  ...userSummaryFromResponse(responseData),
  role: responseData.role,
  companyID: responseData.company_id,
  affiliateCode: responseData.affiliate_code,
  affiliateEnabled: responseData.affiliate_enabled,
  addressLine1: responseData.address_line_1,
  addressLine2: responseData.address_line_2,
  city: responseData.city,
  state: responseData.state,
});

export const userToUpdateRequest = (user: UserDetails) => ({
  first_name: user.firstName,
  last_name: user.lastName,
  email: user.email,
  phone: user.phone,
  role: user.role,
  company_id: user.companyID,
  point: user.point,
});
